export default {
  methods: {
    toCsv(arr, mappings, seperator = ',') {
      /*
        Example:
        const records = [
          {
            client:{firstName:"",lastName:""}
            counselor:{firstName:"",lastName:""}
          },
        ]
        const csv = this.toCsv(records, [
            { header: 'Counseler', mapper: (x) => `${x.counselor.firstName} ${x.counselor.lastName}`},
            { header: 'Client', mapper: (x) => `${x.client.firstName} ${x.client.lastName}`},
        ])
      */
      const keys = Object.keys(mappings);
      if(keys.length === 0)
        return null;

      let csv = "";

      for(const mapping of mappings) {
        csv += `"${mapping.header}"${seperator}`;
      }
      csv = csv.substring(0, csv.length - 1);

      for(const obj of arr) {
        csv += '\n';

        for(const mapping of mappings) {
          csv += `"${mapping.mapper(obj)}"${seperator}`;
        }
        csv = csv.substring(0, csv.length - 1);
      }

      return csv;
    },
    downloadCsv(csv, title) {
      var downloadLink = document.createElement("a");
      var blob = new Blob(["\ufeff", csv]);
      var url = URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = title;
    
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
  }
};
